export default list  => {
    return list.fields.map(f => {
        f.value = '';
        f.order = f.order || '';
        list.project[f.field] = 1;
        if ( typeof f.width == 'string' ) return f.width;
        if ( typeof f.width == 'number' ) return f.width + 'px';
        return (list.width || 100)+'px'
    }).join(' ');
}